var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"miniStatsBox mt-4 h-100"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('p',[_vm._v(_vm._s(_vm.value))]),_c('div',{style:({'background' : _vm.iconColor})},[_c('i',{class:_vm.icon})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }